<button
  class="flex w-4 h-4"
  [matMenuTriggerFor]="menuTooltipBox"
  #menuTrigger="matMenuTrigger"
>
  <ui-icon [attr.name]="icon" [attr.fill]="fill" size="16" m-size="16" />
</button>

<mat-menu #menuTooltipBox="matMenu" class="bg-white">
  <div
    class="box-border p-5 w-[272px] flex flex-col gap-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Content Proyection -->
    <ng-content select="[menuTooltipContent]"></ng-content>

    <div class="flex justify-end">
      <ui-button
        type="primary"
        responsive="false"
        size="sm"
        button-text="Entendido"
        (clicked)="menuTrigger.closeMenu()"
      />
    </div>
  </div>
</mat-menu>
